module.exports = __webpack_public_path__ + "media/images/icon__email-0d624d1e0ad4e541bde8feba67748e11.png";